import { __assign, __rest } from "tslib";
import React from 'react';
import { useIsMounted } from '../utils/hooks/useIsMounted';
import NoScript from '../NoScript';
import { useLazyLoading } from './useLazyLoading';
var LazyLoadingImage = function (_a) {
    var children = _a.children, innerRef = _a.innerRef, props = __rest(_a, ["children", "innerRef"]);
    var _b = useLazyLoading(), enableLazyLoading = _b.enableLazyLoading, supportsNativeLazy = _b.supportsNativeLazy, ref = _b.ref, inView = _b.inView;
    var isMounted = useIsMounted();
    if (!enableLazyLoading || supportsNativeLazy) {
        return React.createElement("img", __assign({ alt: "", ref: innerRef }, props, { loading: 'lazy' }));
    }
    return (React.createElement(React.Fragment, null,
        !isMounted && (React.createElement(NoScript, null,
            React.createElement("img", __assign({ alt: "" }, props)))),
        inView ? (React.createElement("img", __assign({ ref: function (node) {
                ref(node);
                innerRef && innerRef(node);
            }, alt: "" }, props, { loading: 'lazy' }))) : (React.createElement("svg", { ref: ref, width: props.width, height: props.height, style: props.style, "data-hook": props['data-hook'] }))));
};
LazyLoadingImage.displayName = 'LazyLoadingImage';
export default React.memo(LazyLoadingImage);
//# sourceMappingURL=LazyLoadingImage.js.map